module.exports = __webpack_public_path__ + "static/media/white.0e80611f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/white.png
// module id = 138
// module chunks = 0